import React from 'react';
import {Button} from 'antd';
import HeroSection from '../../components/site/HeroSection';
import ProductSwitchShowcase from '../../components/site/ProductSwitchShowcase';
import SectionTitle from '../../components/site/SectionTitle';
import {useWaitlist} from '../../components/site/WaitlistModal';
import {useSiteContent} from './siteContent';
import styles from './SitePages.module.css';

const HomePage: React.FC = () => {
    const {heroMetrics, home, waitlistCta} = useSiteContent();
    const {openWaitlist} = useWaitlist();

    return (
        <div className={styles.page}>
            <section className={styles.section}>
                <HeroSection
                    description={home.hero.description}
                    eyebrow={home.hero.eyebrow}
                    metrics={heroMetrics}
                    panelDescription={home.hero.panelDescription}
                    panelLabel={home.hero.panelLabel}
                    panelTitle={home.hero.panelTitle}
                    compact
                    title={home.hero.title}
                />
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={home.section.description}
                    eyebrow={home.section.eyebrow}
                    title={home.section.title}
                />
                <div className="site-section"/>
                <ProductSwitchShowcase items={home.products}/>
            </section>

            <section className={styles.section}>
                <div className={styles.ctaPanel}>
                    <div>
                        <span className="site-eyebrow">{home.ctaEyebrow}</span>
                        <h2>{home.ctaTitle}</h2>
                        <p>{home.ctaDescription}</p>
                    </div>
                    <div className={styles.ctaActions}>
                        <Button size="large" type="primary" onClick={openWaitlist}
                                style={{height: 48, paddingInline: 32, fontSize: 16}}>
                            {waitlistCta.label}
                        </Button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePage;
